module.exports = __webpack_public_path__ + "img/contact-phone.436a4912.png";